import { SvgImage1 } from '@loomhq/lens';
import React from 'react';
import { connect } from 'react-redux';

import {
  endThumbnailFlow,
  endVideoSettingsFlow,
  startThumbnailFlow,
} from 'actions/editor';
import { requestVideoPlayerLeaveFullScreen } from 'actions/videoPlayer';
import { toggleViewerInsightsUI } from 'actions/viewerInsights';
import {
  ADD_THUMBNAIL_UPGRADE_BUTTON_CLICKED,
  CUSTOM_THUMBNAIL_CLICKED,
  SHARE_PAGE_EDITOR_FAB_PRO_UPSELL,
} from 'constants/events';
import { clearCTAWidgetState } from 'creators/editor';
import {
  handleToggleTranscriptCreator,
  removeVideoThumbnail,
} from 'creators/shareVideo';
import * as analytics from 'utilities/analytics';
import * as device from 'utilities/device';

import { hasScope } from 'selectors/scopes';
import { selectIsActive } from 'selectors/viewerInsights';

import CollapsibleSideButton from '../collapsible-side-button';
import { VIDEO_THUMBNAIL_ACCESS } from '../../../../../shared/constants/scopes';
import {
  OG_THUMB_FULL,
  THUMB_FULL,
} from '../../../../../shared/constants/video';

import UpgradeTooltip from 'components/upgrade-tooltip';

class CustomThumbnailButton extends React.Component {
  render() {
    const {
      collaboratePermissions,
      currentUserIsOwner,
      disabled,
      hasThumbnailScope,
      isCollapsed,
      onRemoveCoverClick,
      thumbnails,
      videoId,
      videoIsTeamShared,
    } = this.props;

    const hasOgThumbnail = thumbnails[OG_THUMB_FULL];
    const editText = hasOgThumbnail ? 'Edit Thumbnail' : 'Remove Thumbnail';
    const editAction = hasOgThumbnail
      ? this.handleAddCoverClick
      : onRemoveCoverClick.bind(null, videoId);

    let button;

    if (hasThumbnailScope) {
      button = thumbnails[THUMB_FULL] ? (
        <CollapsibleSideButton
          icon={<SvgImage1 />}
          isCollapsed={isCollapsed}
          isDisabled={disabled}
          onClick={editAction}
        >
          {editText}
        </CollapsibleSideButton>
      ) : (
        <CollapsibleSideButton
          icon={<SvgImage1 />}
          isCollapsed={isCollapsed}
          isDisabled={disabled}
          onClick={this.handleAddCoverClick}
        >
          Thumbnail
        </CollapsibleSideButton>
      );
    } else {
      button = (
        <UpgradeTooltip
          analyticsEvent={ADD_THUMBNAIL_UPGRADE_BUTTON_CLICKED}
          placement="leftCenter"
          title="Thumbnail"
        >
          <CollapsibleSideButton
            icon={<SvgImage1 />}
            isCollapsed={isCollapsed}
            isDisabled
          >
            Thumbnail
          </CollapsibleSideButton>
        </UpgradeTooltip>
      );
    }

    return (
      (currentUserIsOwner ||
        videoIsTeamShared ||
        collaboratePermissions.write) &&
      !device.isMobile &&
      button
    );
  }

  handleUpgradeNowClick = () => {
    analytics.track(SHARE_PAGE_EDITOR_FAB_PRO_UPSELL, {
      fab_type: 'custom_thumbnail',
    });
    window.location.href = '/account-settings?showUpgrade=true#billing';
  };

  handleAddCoverClick = () => {
    const {
      areThumbnailSettingsOpen,
      areVideoCtaSettingsOpen,
      areVideoSettingsOpen,
      areViewerInsightsOpen,
      endCTAEditing,
      endThumbnailFlow,
      endVideoSettingsFlow,
      isVideoPlayerFullScreen,
      requestVideoPlayerLeaveFullScreen,
      startThumbnailFlow,
      toggleViewerInsightsUI,
      isTranscriptVisible,
      handleToggleTranscriptCreator,
    } = this.props;

    if (areThumbnailSettingsOpen) {
      endThumbnailFlow();

      return;
    }

    analytics.track(CUSTOM_THUMBNAIL_CLICKED);

    if (areVideoCtaSettingsOpen) {
      endCTAEditing();
    }

    if (areViewerInsightsOpen) {
      toggleViewerInsightsUI();
    }

    if (areVideoSettingsOpen) {
      endVideoSettingsFlow();
    }

    if (isTranscriptVisible) {
      handleToggleTranscriptCreator();
    }

    // we only request leaving full screen if already full screen,
    // otherwise we queue up the request to leave full screen
    if (isVideoPlayerFullScreen) {
      requestVideoPlayerLeaveFullScreen();
    }

    startThumbnailFlow();
  };
}

const mapStateToProps = state => {
  const {
    current_user_is_owner,
    video_is_team_shared,
    video,
  } = state.share_video;

  return {
    areThumbnailSettingsOpen: state.editor?.thumbnail_flow,
    areVideoCtaSettingsOpen: state.editor?.cta_flow,
    areVideoSettingsOpen: state.editor?.video_settings_flow,
    areViewerInsightsOpen: selectIsActive(state),
    collaboratePermissions: video.collaboratePermissions,
    currentUserIsOwner: current_user_is_owner,
    hasThumbnailScope: hasScope(state, VIDEO_THUMBNAIL_ACCESS),
    isVideoPlayerFullScreen: state.video_player?.full_screen,
    thumbnails: video.thumbnails,
    videoId: video.s3_id,
    videoIsTeamShared: video_is_team_shared,
    workspaces: state.workspace.workspaces,
  };
};

const mapDispatchToProps = dispatch => ({
  endCTAEditing: () => dispatch(clearCTAWidgetState()),
  endThumbnailFlow: () => dispatch(endThumbnailFlow()),
  endVideoSettingsFlow: () => dispatch(endVideoSettingsFlow()),
  onRemoveCoverClick: videoId => dispatch(removeVideoThumbnail(videoId)),
  requestVideoPlayerLeaveFullScreen: () =>
    dispatch(requestVideoPlayerLeaveFullScreen()),
  startThumbnailFlow: () => dispatch(startThumbnailFlow()),
  toggleViewerInsightsUI: () => dispatch(toggleViewerInsightsUI()),
  handleToggleTranscriptCreator: () =>
    dispatch(handleToggleTranscriptCreator()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomThumbnailButton);
